import { FC } from 'react'

import clsx from 'clsx'

import TickIcon from 'shared/icons/tick_green_icon.svg'

import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  icon?: string
  name?: string
  isSelected?: boolean
}

export const CardSelectSmall: FC<Props> = ({ icon, name, isSelected }) => {
  return (
    <Paper padding={[8, 16]}>
      <div className={s.container}>
        <div className={s.left}>
          <img
            src={icon}
            alt=""
          />

          <div className={s.center}>{name}</div>
        </div>

        <div className={clsx(!isSelected && s.right)}>
          {isSelected ? (
            <img
              src={TickIcon}
              alt=""
            />
          ) : (
            <div />
          )}
        </div>
      </div>
    </Paper>
  )
}
